import styles from "./TermPopUp.module.css";
import React from "react";

interface TermProps {
    term: string;
    onClose: () => void;
}

//데이터 사업 규정 팝업
const TermPopUp: React.FC<TermProps> = ({term, onClose}) => {
    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.popup} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        Terms of Use
                    </div>
                    <button onClick={onClose} className={styles.closeButton}>
                        ×
                    </button>
                </div>
                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{__html: term}}
                />
            </div>
        </div>
    )
}

export default TermPopUp;